import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {
  ReactiveFormsModule,
  FormsModule,
  FormGroup,
  FormBuilder,
} from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { AccordionComponent } from '../../../shared/components/accordion/accordion.component';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { BaseComponent } from '../../../shared/utils/base.component';
import { Router, ActivatedRoute } from '@angular/router';
import { BillingService } from '../../../services/billing.service';
import { ClaimsService } from '../../../services/claims.service';
import { SectionsService } from '../../../services/sections.service';
import { UserService } from '../../../services/user.service';
import {
  DialogConfig,
  DialogService,
} from '../../../shared/services/dialog.service';
import { performValidation } from '../../../shared/utils/validation.util';
import { DropdownSelectComponent } from '../../../shared/components/dropdown-select/dropdown-select.component';

@Component({
  selector: 'ppl-add-lookup-value',
  standalone: true,
  imports: [
    ButtonComponent,
    NzFormModule,
    ReactiveFormsModule,
    FormsModule,
    NzCardModule,
    NzInputModule,
    NzToolTipModule,
    CommonModule,
    NzDatePickerModule,
    NzToolTipModule,
    NzSelectModule,
    NzButtonModule,
    AccordionComponent,
    DropdownSelectComponent
  ],
  templateUrl: './add-lookup-value.component.html',
  styleUrl: './add-lookup-value.component.css',
})
export class AddLookupValueComponent extends BaseComponent implements OnInit {
  pageTitle = 'Add New Lookup Value';
  mode = 'edit';
  isNew = true;
  lookupValueForm!: FormGroup;
  lookupDomainList: any[] = [];
  programName: any;
  savedData: any = {};
  @Input() isEditLookup: any;
  @Output() cancel = new EventEmitter<boolean>();
  private dialogSvc = inject(DialogService);
  @ViewChild('confirmationDialog') confirmationDialog!: TemplateRef<any>;

  constructor(
    private fb: FormBuilder,
    private sectionsService: SectionsService,
    private router: Router,
    private route: ActivatedRoute,
    private claimsService: ClaimsService,
    private userService: UserService,
    private billingService: BillingService
  ) {
    super();
  }

  ngOnInit(): void {
    this.lookupValueForm = this.fb.group({
      lkpDomainId: [''],
      lkpValueName: [''],
      lkpValueDesc: [''],
      lkpValueCode: [''],
    });

    const program = this.userService.getSelectedProgram();
    this.programName = program?.program_code;
    this.secData = this.sectionsService.getSectionData(
      this.programName,
      'lookupValueConfig'
    );
    this.savedData = this.claimsService.getFormData('configLookupValue');
    const action = this.isEditLookup ? 'update' : 'add';
    this.pageTitle =
      action == 'update'
        ? `Details for ID: ${this.savedData?.lkpValueId}`
        : this.pageTitle;
    this.mode = this.isEditLookup ? 'read' : 'edit';
    this.isNew = !this.isEditLookup;
    this.billingService
      .getLookupDomainDropdown(this.programName)
      .subscribe((data: any) => {
        this.lookupDomainList = data?.responsedata;
      });
  }

  goBack() {
    this.cancel.emit(true);
  }

  onCancel() {
    this.mode = 'read';
    this.validationErrors = {};
    this.lookupValueForm.reset();
  }

  onAdd(action: string) {
    this.validationErrors = performValidation(
      this.lookupValueForm.getRawValue(),
      this.secData,
      'Next'
    );
    const payload = {
      ...this.lookupValueForm.getRawValue(),
      programCode: this.programName,
      forProgram: 'All',
      lkpValueId: action === 'add' ? '0' : this.savedData?.lkpValueId,
      isActive: true,
    };

    if (Object.keys(this.validationErrors).length === 0) {
      this.billingService
        .addAndUpdateLookupValue(payload, action)
        .subscribe((data: any) => {
          this.cancel.emit(true);
        });
    } else {
      return;
    }
  }

  onEdit() {
    this.mode = 'edit';
    const data = this.savedData;
    this.lookupValueForm.patchValue(data);
  }

  onDelete() {
    this.openConfirmationPopup();
  }

  openConfirmationPopup() {
    const dialogConfig: DialogConfig = {
      title: 'Confirmation',
      isOkText: 'Ok',
      size: 'medium',
      position: 'top',
      showClose: true,
      showButtons: true,
    };

    this.dialogSvc.openDialog(
      this.confirmationDialog,
      dialogConfig,
      () => this.deleteLookupValue(),
      () => this.handleCancel()
    );
  }

  handleCancel() {}

  deleteLookupValue() {
    this.billingService
      .deleteLookupValue(this.programName, this.savedData.lkpValueId)
      .subscribe((data: any) => {
        if (data.status === 200) {
          this.cancel.emit(true);
        }
      });
  }
}
